module.exports = __webpack_public_path__ + "img/wx2.dcfb5f16.jpg";